import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      margin: '10px 0 20px',
      justifyContent: 'center',
    },
    appBar: {
      bottom: 0,
      borderRadius: '8px 8px 0 0',
      background: 'linear-gradient(180deg, #2D6DF6 0%, #0133A0 100%)',
      alignSelf: 'end',
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    toolbar: {
      justifyContent: 'center',
      display: 'contents',
    },
    buttonDetail: {
      width: '80px',
      opacity: '40%',
      border: '4px solid #FFFFFF',
      borderRadius: 20,
      height: '1px',
    },
    card: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '382px'),
      height: 'auto',
      borderRadius: '8px',
      opacity: 1,
      boxShadow: 'none',
      background: 'linear-gradient(180deg, #2D6DF6 0%, #0133A0 100%)',
      alignSelf: 'center',
      justifyItems: 'center',
    },
    total: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '30px',
      color: '#FFFFFF',
      textAlign: 'center',
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    divider: {
      background: '#ffffff',
      '&.MuiDivider-inset': {
        margin: '0 20px',
      },
    },
    labelTotal: {
      fontFamily: 'SuraSans-Ligera',
      fontSize: '12px',
      textAlign: 'center',
      margin: '10px 0',
      color: '#ffffff',
    },
    btnContainer: {
      width: '100%',
      textAlign: 'center',
    },
    divIcon: {
      display: 'flex',
      justifyContent: 'center',
      margin: '20px 0',
      alignItems: 'center',
      height: '10px',
    },
    iconStyle: {
      color: '#E3E829',
    },
    labelReceipt: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '14px',
      color: '#E3E829',
    },
  }),
);

export default useStyles;
